import angular from 'angular';
import lmiSecurities from './lmiSecurities';

export default angular
  .module('components.lmiSecurities', [])
  .component('lmiSecurities', lmiSecurities).name;
